import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-Location-Green",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Location Green",
    description: "Location-Green",
    image: require("./Location-Green.svg"),
    svgIcon: require("./Location-Green.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.locationgreencls1{fill:#009f4d;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
            <path class="locationgreencls1" d="M84.9,36.09A32.49,32.49,0,0,1,83,46.89c-.36.94-.73,1.87-1.14,2.78s-.86,1.81-1.31,2.7-.76,1.5-1.16,2.24q-1.23,2.23-2.49,4.47c-.36.64-.74,1.27-1.12,1.89l-2.55,4.1c-.35.56-.71,1.11-1.08,1.66q-1.29,1.93-2.61,3.87l-1.16,1.68c-.84,1.18-1.68,2.36-2.54,3.53S64.27,77.92,63.48,79s-1.69,2.22-2.55,3.32-1.58,2-2.38,3S56.86,87.38,56,88.41s-1.55,1.87-2.34,2.8-1.69,2-2.54,3c-.13.15-.26.28-.39.42a2,2,0,0,1-2.86,0c-.23-.24-.45-.48-.66-.73l-2.08-2.43-2.59-3.09c-.76-.92-1.51-1.84-2.26-2.77-.88-1.1-1.75-2.21-2.61-3.32s-1.63-2.1-2.44-3.16-1.67-2.24-2.49-3.36-1.64-2.26-2.44-3.4-1.66-2.38-2.47-3.58S26.2,66.28,25.41,65s-1.68-2.67-2.5-4c-.42-.67-.81-1.35-1.21-2q-1.31-2.18-2.48-4.43c-.39-.77-.8-1.53-1.18-2.3s-.87-1.81-1.32-2.7a29.43,29.43,0,0,1-1.13-2.81,30.66,30.66,0,0,1-1.27-4.62,30.19,30.19,0,0,1-.56-4.24,36.31,36.31,0,0,1,0-5.11,27,27,0,0,1,.32-2.69,34.78,34.78,0,0,1,1.24-5.05c.36-1.06.76-2.11,1.2-3.13a26.81,26.81,0,0,1,1.2-2.47,36.93,36.93,0,0,1,2.43-3.87,31.35,31.35,0,0,1,2.42-3c.81-.86,1.64-1.7,2.51-2.51a33,33,0,0,1,3.6-2.86A36,36,0,0,1,34.9,3.8a37.46,37.46,0,0,1,4.7-1.66A36.16,36.16,0,0,1,44,1.22,28.62,28.62,0,0,1,47.33.91c1.13,0,2.26-.08,3.39,0a31.79,31.79,0,0,1,3.78.34,35.46,35.46,0,0,1,6.36,1.51c1,.36,2.08.77,3.09,1.21a30.76,30.76,0,0,1,5.34,2.93c.78.54,1.55,1.1,2.31,1.67A31.46,31.46,0,0,1,75.38,12a34.13,34.13,0,0,1,2.41,2.82,30.44,30.44,0,0,1,2.52,3.76c.4.72.78,1.45,1.16,2.17a29.91,29.91,0,0,1,1.34,3.14A32.24,32.24,0,0,1,84,28,34.46,34.46,0,0,1,84.9,36.09ZM49,17.47a18.86,18.86,0,0,0-3.18.32,18.27,18.27,0,0,0-6.07,2.27,18.47,18.47,0,0,0-4.92,4.18A18.77,18.77,0,0,0,32.45,28a20.27,20.27,0,0,0-1.18,3.27,14.89,14.89,0,0,0-.5,3.31,17,17,0,0,0,.65,5.85,19.66,19.66,0,0,0,1.23,3.14,18.46,18.46,0,0,0,2.54,3.75,18,18,0,0,0,3.72,3.25A18.69,18.69,0,0,0,48,53.61a18.69,18.69,0,0,0,4.42-.23,19.38,19.38,0,0,0,4.87-1.51A17.66,17.66,0,0,0,61,49.59a18.37,18.37,0,0,0,2.9-2.88,20.41,20.41,0,0,0,1.76-2.66,17.13,17.13,0,0,0,1.52-3.71,16.46,16.46,0,0,0,.61-3.49,16.7,16.7,0,0,0,0-3A15.79,15.79,0,0,0,66.92,30,20.51,20.51,0,0,0,65.64,27a19.1,19.1,0,0,0-2.47-3.44,18.27,18.27,0,0,0-2.47-2.27,18.7,18.7,0,0,0-5-2.73A19.24,19.24,0,0,0,49,17.47Z" transform="translate(-13.68 -0.86)"/>
         </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
